export default "/assets/5dda00db99f7190b.png"